import selectLocalExercise from './selectLocalExercise';
const selectLastSubmission = (state, id) => {
  const localExercise = selectLocalExercise(state, id);
  if (localExercise === undefined) {
    return undefined;
  }
  return localExercise.lastSubmission;
};
export default selectLastSubmission;